import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Images } from "../Components/Images";
import { FaCopy } from "react-icons/fa6";
import { CURRENT_CHAIN_ID } from "../Hooks/useWeb3";
import { userWithdrawAmount } from "../actions/user";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import toast from "react-hot-toast";
import { CHAINS } from "../Config/env";

const initialFormValue = {
  amount: "", escrowAddress: "", address: "", chainId: ""
};

const WithdrawModal = ({ show, handleShow, handleClose, userData, currencyName, balance }) => {

  const [errors, setErrors] = useState({});
  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [ismax, setismax] = useState(false);



  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let error = { ...errors };
      error[`${name}`] = "";
      let Formvalue = { ...formvalue, [name]: value };
      setFormvalue(Formvalue);
      setErrors(errors);
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const validation = (value) => {
    try {
      let error = { ...errors };
      const addressRegex = "^(0x)[0-9A-Fa-f]{40}$";
      var pattern = new RegExp(addressRegex);


      let decimal = /^\d+(\.\d+)?$/;
      var decimalpattern = new RegExp(decimal);


      if (isEmpty(value.amount)) {
        error["amount"] = "Amount is required";
      }
      if (isEmpty(value.amount?.match(decimalpattern))) {
        error["amount"] = "amount must be a valid number";
      }

      else if (!isEmpty(value.amount) && parseFloat(value.amount) > parseFloat(balance)) {
        error["amount"] = "Amount is greater than balance";
      }
      else {
        error["amount"] = "";
      }
      if (isEmpty(value.address)) {
        error["address"] = "Address is required";
      }
      else if (isEmpty(value.address?.match(pattern))) {
        error["address"] = "Enter Valid Address";
      }
      else {
        error["address"] = "";
      }
      console.log(error, "VALUE")
      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };



  const handleSubmit = async () => {
    try {

      let chainId = currencyName == 'MATIC' ? CHAINS[0].CHAIN_ID : CHAINS[0].CHAIN_ID

      let oj = {
        amount: ismax ? balance : formvalue.amount,
        escrowAddress: userData?.escrowAddress,
        address: formvalue.address,
        chainId: chainId
      };
      let isValidate = validation(oj);
      setErrors(isValidate);
      if (!ObjectIsempty(isValidate)) {
        return true;
      }
      let { status, message, result } = await userWithdrawAmount(oj);
      if (status == true) {
        toast.success("Withdraw Successfully");
        handleClose();
      } else {
        toast.error(message);
        handleClose();
      }
      handleClose();
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };






  return (
    <>
      <Modal
        centered
        size="md"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="deposit_modal withdraw_modal"
      >
        <Modal.Body className="cmn__modal">
          <p className="text-end m-0 modal__closer" onClick={handleClose}>
            <i class="fa-solid fa-xmark" />
          </p>
          <h5 className="title_txt mb-0">Withdraw</h5>

          <div className="content_sec mt-3">
            <div className="row">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <div className="">
                  <label className="label">Amount</label>
                  <div className="input_label_wraper mt-2">
                    <input type="text" className=""
                      placeholder={`${ismax ? balance : 0}`}
                      name='amount'

                      onChange={handleChange}


                    />
                    {/* <button className="max_inp">Max</button> */}
                    {/* <span className="network_txt">{currencyName}</span> */}
                    <button onClick={() => setismax(true)} className="network_txt">Max</button>
                  </div>
                  <span>
                    <span className="text-danger">{errors.amount}</span>
                  </span>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="">
                  <label className="label">Withdraw Address</label>
                  <div className="input_label_wraper mt-2">
                    <input
                      type="text"
                      className="w-100"
                      placeholder="Withdraw Address"
                      name='address'
                      onChange={handleChange}
                    />
                  </div>
                  <span>
                    <span className="text-danger">{errors.address}</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="wallet_balance_wrap d-flex align-items-center justify-content-center">
              <p className="mb-0">
                Wallet Balance : <span className="value">{Number(balance) > 0 ? balance : "0"} {currencyName}</span>
              </p>
            </div>
          </div>

          <div className="d-flex mt-4 align-items-center justify-content-center">
            <button className="primary_grad_btn rounded-2 withdraw_btn px-4 py-2"

              onClick={handleSubmit}
            >
              Withdraw
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WithdrawModal;
